document.addEventListener("DOMContentLoaded", function () {
  const productForms = document.querySelectorAll(".productForm");

  // Loop through each form and attach an event listener
  productForms.forEach(function (form) {
    form.addEventListener("submit", function (event) {
      event.preventDefault();

      const formData = new FormData(form);

      const button = form.querySelector(".productForm-submit");
      button.disabled = true;
      button.querySelector("span").innerText = "Adding...";

      setTimeout(function () {
        button.querySelector("span").innerHTML = `Item added to cart!`;
      }, 1000);

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          updateCart();
          button.disabled = false; // Re-enable the button
          button.querySelector("span").innerText = "Add to Cart";
        })
        .catch((error) => {
          button.disabled = false;
          button.querySelector("span").innerText = "Add to Cart";
          console.error("Error adding to cart:", error);
        });
    });
  });

  // Optionally update the cart details without reloading the page
  function updateCart() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const cartToggleItems = document.getElementsByClassName("cartToggle-items")[0];

        if (cart.item_count > 0) {
          // Show the element and update the item count
          cartToggleItems.textContent = cart.item_count;
          cartToggleItems.style.display = "inline"; // Show element
        } else {
          // Hide the element if the cart is empty
          cartToggleItems.style.display = "none";
        }
      })
      .catch((error) => console.error("Error fetching cart:", error));
  }
});
